import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { Container } from '../Container';

interface WrapperProps {
  $tone?: 'light';
  $underHeader?: boolean;
  $heightAuto?: boolean;
}

export const Wrapper = styled.div.withConfig({ componentId: 'sc-182x8l6-0' })<WrapperProps>`
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: var(--c-bg-alt);
    min-height: 380px;
    z-index: 10;

    ${(props) => props.theme.breakpoint.Sm} {
        min-height: 440px;
    }

    ${Container} {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
    }

    ${({ $tone }) =>
      $tone === 'light'
        ? css`
                  background-color: var(--c-bg-main);
              `
        : undefined}

    ${({ $underHeader }) =>
      $underHeader &&
      css`
            padding-top: 72px; // Header height in this breakpoint - padding bottom

            ${(props) => props.theme.breakpoint.Sm} {
                padding-top: 90px; // Header height in this breakpoint
            }
        `}

    ${({ $heightAuto }) =>
      !$heightAuto &&
      css`
            min-height: 380px;

            ${(props) => props.theme.breakpoint.Sm} {
                min-height: 530px;
            }
        `}
`;

export const Media = styled.div.withConfig({ componentId: 'sc-182x8l6-1' })`
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
`;

interface ImageProps {
  $imagePosition?: 'bottom';
}

export const Image = styled.img.withConfig({ componentId: 'sc-182x8l6-2' })<ImageProps>`
    width: 100%;
    height: 100%;
    object-fit: cover;

    ${({ $imagePosition }) =>
      $imagePosition === 'bottom'
        ? css`
                  object-position: bottom;
              `
        : undefined}
`;

interface HeroContentProps {
  $limitWidth?: boolean;
}

export const HeroContent = styled.div.withConfig({ componentId: 'sc-182x8l6-3' })<HeroContentProps>`
    position: relative;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${size(4)} 0;
    color: var(--c-hero-fg);
    z-index: 1;

    ${({ $limitWidth }) =>
      $limitWidth &&
      css`
            ${(props) => props.theme.breakpoint.Md} {
                max-width: 50%;
            }
        `}
`;
